export default __webpack_public_path__ + "static/media/logo-admin.81aa517d.png";